import { Box, Button, Typography, useTheme } from '@mui/material';
import { useJobCardStyles } from './job-card.styles';

const JobCard = ({ job, backgroundColor, textColor, showBorder }) => {
  const classes = useJobCardStyles();
  const theme = useTheme()

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      className={classes.root}
      sx={{
        backgroundColor: '#f5f5f5',
        border: `${theme.palette.primary.main} solid 4px`,
      }}
    >
      <Box className={classes.imgWrapper}>
        <img src={job.imageUrl} alt={job.title} className={classes.img} />
      </Box>
      <Typography
        // sx={{ color: textColor ?? 'inherit' }}
        className={classes.jobTitle}
      >
        {job.title}
      </Typography>
      <Typography
        // sx={{ color: textColor ?? 'inherit' }}
        className={classes.location}
      >
        {job.jobLocation}
      </Typography>
      <a href={job.jobLink} target='_blank' rel='noreferrer'>
        <Button variant='contained' sx={{ maxWidth: 'max-content', color: 'white' }}>
          apply now
        </Button>
      </a>
    </Box>
  );
};

export default JobCard;
